<div *ngIf="content.title">
  <div class="skymiles-landing-page-quick-links">
    <h3>{{ content.title }}</h3>
    <div class="skymiles-landing-page-quick-links__card">
      <idp-card
        (notify)="createMemberShipCard(content.membershipCard)"
        *ngFor="let card of content.cards"
        [contents]="card"
      ></idp-card>
    </div>
  </div>
</div>
